import React, {useEffect} from "react";
import Container from 'react-bootstrap/Container';
import '../Lg.css';
import {lgSetup} from "../../../backend/LgSetup";
import {TildaB} from "./common/TildaB";
import {logPageOpened} from "../../model/utils";
import {
    calculateFullInfoUrl,
    calculateLeadGenerationUrl,
    calculateShortPageToLmUrl,
    calcWhere
} from "./common/LgHelper";
import {appdata} from "../../../logic_tmp/appdata/AppData";


export function LgShortFooter() {
    appdata.viewType = "ShortPage"
    useEffect(() => {
        logPageOpened(appdata.parentPath,appdata.viewType)
    }, []);
    return (
        <div>
            <Container>
                <TildaB>
                    <div className="fontBig center">
                        Посмотрите несколько коротких фрагментов из этого концерта
                    </div>
                </TildaB>
                {Object.keys(lgSetup.concerts[appdata.cmp.concert].demoLms).map(item =>
                    <TildaB key={item}>
                        <div>
                            <div className="normal">
                                {lgSetup["lms"][item]["desc"]}
                            </div>
                            <a href={calculateShortPageToLmUrl(appdata,item)} target="_parent"
                               className="myButton">{lgSetup["lms"][item]["buttonName"]}</a>
                        </div>
                    </TildaB>
                )}
                <TildaB>
                    <div className="fontBig center"> Приглашать ли вас на эти концерты в <strong
                        className="normal">{calcWhere(appdata)}?</strong>
                    </div>
                </TildaB>
                <TildaB>
                    <div>
                        <a href={calculateLeadGenerationUrl(appdata)} target="_parent"
                           className="myButton myButtonYellow">Да, пригласите меня!</a>
                    </div>
                </TildaB>
                <TildaB>
                    <div>
                        <a id ="toConcertFull" href={calculateFullInfoUrl(appdata)} target="_parent"
                           className="myButton myButton">Посмотреть полную информацию о концерте</a>
                    </div>
                </TildaB>
            </Container>
        </div>
    );
}

